import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

const NotifContext = createContext({ notifications: [], clearAll: () => {}, dismiss: () => {} });

export function NotificationsProvider({ children }) {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const esRef = useRef(null);

  useEffect(() => {
    if (!user) { if (esRef.current) { esRef.current.close(); esRef.current = null; } return; }

    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) return;

    const es = new EventSource(`/api/notifications/stream?token=${token}`);
    esRef.current = es;

    const addNotif = (type, data) => {
      const notif = { id: Date.now(), type, ...data, read: false, at: new Date() };
      setNotifications(prev => [notif, ...prev].slice(0, 20));
    };

    es.addEventListener('sale',  e => addNotif('sale',  JSON.parse(e.data)));
    es.addEventListener('order', e => addNotif('order', JSON.parse(e.data)));
    es.onerror = () => { es.close(); esRef.current = null; };

    return () => { es.close(); esRef.current = null; };
  }, [user]);

  const dismiss = (id) => setNotifications(prev => prev.filter(n => n.id !== id));
  const clearAll = () => setNotifications([]);
  const unread = notifications.filter(n => !n.read).length;

  return (
    <NotifContext.Provider value={{ notifications, unread, dismiss, clearAll }}>
      {children}
    </NotifContext.Provider>
  );
}

export const useNotifications = () => useContext(NotifContext);
